import { useEffect, useRef } from "react";
import { getCurrentCulture } from "@utils";
import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import { LMTWidgetElement } from "@data-types/live-widget/LMTWidgetElement";
import { BrWidgetDefaultConfig } from "../config";
import { useLiveWidgetStore } from "@state/hooks/live-widgets";

let language = "";
/** @returns  language that is */
function getCurrentLanguageForSIR(): string {
	let lang = getCurrentCulture();

	if (lang === "sq") {
		lang = "sqi";
	} else if (lang === "sv") {
		lang = "se";
	}
	language = lang;
	return lang;
}

export function useBRContainerCycles(
	ref: HTMLDivElement | null,
	eventId: string,
	location: WidgetLocation
): boolean {
	const store = useLiveWidgetStore();

	// On component will unmount
	useEffect(() => {
		return () => {
			if (window.SIR == undefined) {
				return;
			}
			if (ref != null) {
				SIR("removeWidget", ref);
				return;
			}
		};
	}, [ref]);

	const mountedWidget = useRef<LMTWidgetElement | null>();

	if (window.SIR == undefined) {
		// We are not mounted if it is undefined
		return false;
	}

	const myWidget = store.findActiveLmtWidget(eventId, location);

	if (myWidget?.isError) {
		// an error occurred on widget initialization; execute fallback
		return false;
	}

	// This is initial add.
	if (ref != null && myWidget != null && mountedWidget.current == null) {
		if (language !== getCurrentLanguageForSIR()) {
			SIR?.("changeLanguage", getCurrentLanguageForSIR());
		}

		const lmtOptions = Object.assign(
			{},
			BrWidgetDefaultConfig,
			myWidget.BRWidgetOptions,
			{ matchId: myWidget.matchId }
		);

		SIR("addWidget", ref, "match.lmtPlus", lmtOptions);

		mountedWidget.current = { ...myWidget };
		// We are mounted
		return true;
	}

	// This is widget update.
	if (ref != null && myWidget != null && mountedWidget.current != null) {
		const lmtOptions = Object.assign(
			{},
			BrWidgetDefaultConfig,
			myWidget.BRWidgetOptions,
			{ matchId: myWidget.matchId }
		);

		SIR("updateWidget", ref, lmtOptions, () => {});

		mountedWidget.current = { ...myWidget };
		// We are mounted
		return true;
	}

	// This is widget removed.
	if (ref != null && myWidget == null && mountedWidget.current != null) {
		SIR("removeWidget", ref);
		mountedWidget.current = null;
		// We are not mounted
		return false;
	}

	return mountedWidget.current != null || myWidget != null;
}
